(() => {
  const contactDraftKey = 'rsl_rental_contact_draft_v1';
  const contactNames = ['contact[name]', 'contact[email]', 'contact[phone]', 'contact[bedrijf]', 'contact[body]'];

  const readContactDraft = () => {
    try {
      const stored = window.localStorage.getItem(contactDraftKey) || window.sessionStorage.getItem(contactDraftKey) || '{}';
      const value = JSON.parse(stored);
      return value && typeof value === 'object' ? value : {};
    } catch (error) {
      return {};
    }
  };

  const writeContactDraft = (form) => {
    if (!form) return;
    const draft = {};
    contactNames.forEach((name) => {
      const field = form.elements.namedItem(name);
      if (field) draft[name] = field.value || '';
    });
    try {
      window.sessionStorage.setItem(contactDraftKey, JSON.stringify(draft));
      window.localStorage.setItem(contactDraftKey, JSON.stringify({ ...draft, savedAt: new Date().toISOString() }));
    } catch (error) {
      // The request flow remains usable when browser storage is unavailable.
    }
  };

  const restoreContactDraft = (form) => {
    if (!form) return;
    const draft = readContactDraft();
    contactNames.forEach((name) => {
      const field = form.elements.namedItem(name);
      if (field && !field.value && draft[name]) field.value = draft[name];
    });
  };

  const init = (root) => {
    if (!root || root.dataset.rslCoreCartBound) return;
    const eventFields = root.querySelector('[data-rsl-core-event-fields]');
    const moveField = (selector) => {
      const input = root.querySelector(selector);
      const label = input?.closest('label');
      if (label && eventFields && !eventFields.contains(label)) eventFields.appendChild(label);
      return input;
    };
    const eventType = moveField('[data-rslr-event-type]');
    moveField('[data-rslr-audience-count]');
    moveField('[data-rslr-environment]');

    const targets = {
      event: root.querySelector('#rsl-core-quote-event'),
      material: root.querySelector('#rsl-core-quote-material'),
      logistics: root.querySelector('[data-rsl-core-quote-logistics]'),
      contact: root.querySelector('#rsl-core-quote-contact'),
    };
    const form = root.querySelector('form.rslr-quote-form');
    const startDate = root.querySelector('[data-rslr-date-start]');
    const endDate = root.querySelector('[data-rslr-date-end]');
    const flowStatus = root.querySelector('[data-rsl-core-flow-status]');
    const draftStatus = root.querySelector('[data-rsl-v25-draft-status] span:last-child');
    const preflight = root.querySelector('[data-rsl-v30-preflight]');
    const preflightScore = root.querySelector('[data-rsl-v30-preflight-score]');
    const preflightMessage = root.querySelector('[data-rsl-v30-preflight-message]');
    restoreContactDraft(form);

    if (root.querySelector('[data-rsl-v25-request-success]')) {
      try {
        window.sessionStorage.removeItem(contactDraftKey);
        window.localStorage.removeItem(contactDraftKey);
      } catch (error) {
        // A successful request remains valid if storage cleanup is unavailable.
      }
    }

    const syncDates = () => {
      if (!startDate || !endDate) return;
      endDate.min = startDate.value || startDate.min || '';
      if (startDate.value && endDate.value && endDate.value < startDate.value) endDate.value = startDate.value;
    };
    syncDates();
    root.querySelectorAll('[data-rsl-core-quote-step]').forEach((step) => {
      step.querySelector('button')?.addEventListener('click', () => {
        targets[step.dataset.rslCoreQuoteStep]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    root.querySelector('[data-rsl-show-empty-form]')?.addEventListener('click', () => {
      root.setAttribute('data-rsl-show-empty-form', '');
      targets.event?.querySelector('input, select')?.focus();
    });
    const update = () => {
      const hasValue = (field) => Boolean(String(field?.value || '').trim());
      const eventComplete = hasValue(eventType);
      const materialComplete = Boolean(root.querySelector('[data-rslr-quote-list]')?.children.length);
      const periodComplete = Boolean(startDate?.value && endDate?.value && endDate.value >= startDate.value && startDate.checkValidity() && endDate.checkValidity());
      const locationComplete = hasValue(root.querySelector('[data-rslr-location]')) && hasValue(root.querySelector('[data-rslr-transport]'));
      const name = root.querySelector('[name="contact[name]"]');
      const email = root.querySelector('[name="contact[email]"]');
      const contactComplete = hasValue(name) && hasValue(email) && email.checkValidity();
      const termsComplete = Boolean(root.querySelector('[data-rslr-terms-accepted]')?.checked);
      const privacyComplete = Boolean(root.querySelector('[data-rslr-privacy-accepted]')?.checked);
      const states = {
        event: eventComplete,
        material: materialComplete,
        logistics: periodComplete && locationComplete,
        contact: contactComplete && termsComplete && privacyComplete,
      };
      const hasReceipt = Boolean(root.querySelector('[data-rsl-v25-request-success]'));
      root.dataset.rslCartEmpty = String(!states.material && !hasReceipt);
      Object.entries(states).forEach(([key, complete]) => {
        const step = root.querySelector(`[data-rsl-core-quote-step="${key}"]`);
        step?.classList.toggle('is-complete', complete);
        const target = targets[key];
        target?.toggleAttribute('data-rsl-core-complete', complete);
      });
      const completed = Object.values(states).filter(Boolean).length;
      const detailedStates = {
        event: eventComplete,
        material: states.material,
        period: periodComplete,
        location: locationComplete,
        contact: contactComplete,
        terms: termsComplete,
        privacy: privacyComplete,
      };
      const detailedCompleted = Object.values(detailedStates).filter(Boolean).length;
      Object.entries(detailedStates).forEach(([key, complete]) => {
        const item = preflight?.querySelector(`[data-check="${key}"]`);
        item?.classList.toggle('is-complete', complete);
      });
      if (preflight) preflight.dataset.state = detailedCompleted === 7 ? 'ready' : 'incomplete';
      if (preflightScore) preflightScore.textContent = `${detailedCompleted} van 7 compleet`;
      if (preflightMessage) preflightMessage.textContent = detailedCompleted === 7
        ? 'Alles is ingevuld. RSL kan deze aanvraag technisch en logistiek beoordelen.'
        : 'Vul de gemarkeerde onderdelen in. Daarna kan RSL je aanvraag sneller beoordelen.';
      if (flowStatus) {
        const title = flowStatus.querySelector('strong');
        const detail = flowStatus.querySelector('span');
        flowStatus.dataset.state = completed === 4 ? 'ready' : 'progress';
        if (title) title.textContent = completed === 4 ? 'Je gegevens zijn ingevuld' : `${completed} van 4 stappen gereed`;
        if (detail) {
          if (!states.event) detail.textContent = 'Kies het type evenement.';
          else if (!states.material) detail.textContent = 'Voeg minimaal één materiaalregel toe.';
          else if (!periodComplete) detail.textContent = 'Kies een geldige start- en retourdatum.';
          else if (!locationComplete) detail.textContent = 'Vul de locatie in en kies ophalen of bezorgen.';
          else if (!contactComplete) detail.textContent = 'Vul naam en een geldig e-mailadres in.';
          else if (!termsComplete || !privacyComplete) detail.textContent = 'Lees en bevestig de voorwaarden en het privacybeleid.';
          else detail.textContent = 'Controleer je overzicht en de melding bij de verzendknop.';
        }
      }
    };
    root.addEventListener('input', (event) => {
      if (event.target === startDate || event.target === endDate) syncDates();
      if (form && event.target.form === form) writeContactDraft(form);
      if (draftStatus && form && event.target.form === form) draftStatus.textContent = 'Concept zojuist automatisch bewaard.';
      update();
    });
    root.addEventListener('change', (event) => {
      if (event.target === startDate || event.target === endDate) syncDates();
      update();
    });
    form?.addEventListener('invalid', (event) => {
      event.target.setAttribute('aria-invalid', 'true');
    }, true);
    form?.addEventListener('input', (event) => event.target.removeAttribute('aria-invalid'));
    form?.addEventListener('submit', (event) => {
      const submitChecks = {
        event: Boolean(eventType?.value),
        material: Boolean(root.querySelector('[data-rslr-quote-list]')?.children.length),
        period: Boolean(startDate?.value && endDate?.value && endDate.value >= startDate.value),
        location: Boolean(root.querySelector('[data-rslr-location]')?.value && root.querySelector('[data-rslr-transport]')?.value),
        contact: Boolean(root.querySelector('[name="contact[name]"]')?.value && root.querySelector('[name="contact[email]"]')?.checkValidity()),
        terms: Boolean(root.querySelector('[data-rslr-terms-accepted]')?.checked),
        privacy: Boolean(root.querySelector('[data-rslr-privacy-accepted]')?.checked),
      };
      const missing = Object.keys(submitChecks).filter((key) => !submitChecks[key]);
      if (!missing.length) return;
      event.preventDefault();
      const labels = { event: 'evenement', material: 'materiaal', period: 'huurperiode', location: 'locatie en transport', contact: 'contactgegevens', terms: 'voorwaarden', privacy: 'privacytoestemming' };
      if (preflightMessage) preflightMessage.textContent = `Nog invullen: ${missing.map((key) => labels[key]).join(', ')}.`;
      const firstTarget = ['event','material'].includes(missing[0]) ? targets[missing[0]] : missing[0] === 'period' || missing[0] === 'location' ? targets.logistics : targets.contact;
      firstTarget?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    const list = root.querySelector('[data-rslr-quote-list]');
    if (list) new MutationObserver(update).observe(list, { childList: true, subtree: true });
    window.setTimeout(update, 50);
    root.dataset.rslCoreCartBound = 'true';
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-rslr-quote-app]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
